import React, {
    useContext,
    useEffect,
    useState
} from 'react';

import '../styles/Posts.css';

import {
    AiOutlineHeart,
    AiTwotoneHeart
} from "react-icons/ai";

import { FaGlobeAmericas } from "react-icons/fa";
import { IoIosPersonAdd } from 'react-icons/io';

import axios from 'axios';

import {
    GeneralContext
} from '../context/GeneralContextProvider';

import {
    useNavigate
} from 'react-router-dom';


const Post = () => {

    const navigate = useNavigate();

    const { socket } = useContext(GeneralContext);

    const [posts, setPosts] = useState([]);

    const [comment, setComment] = useState('');


    // =========================
    // FETCH POSTS
    // =========================
    const fetchPosts = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/fetchAllPosts`
            );

            setPosts(response.data);

        } catch (error) {
            console.error(
                'Error fetching posts:',
                error
            );
        }
    };


    // =========================
    // INITIAL LOAD
    // =========================
    useEffect(() => {
        fetchPosts();
    }, []);


    // =========================
    // SOCKET REAL-TIME UPDATES
    // =========================
    useEffect(() => {

        const handleLikeUpdated = ({ post }) => {

            if (!post) return;

            setPosts(prevPosts =>
                prevPosts.map(existingPost =>
                    existingPost._id === post._id
                        ? post
                        : existingPost
                )
            );
        };


        const handleCommentUpdated = ({ post }) => {

            if (!post) return;

            setPosts(prevPosts =>
                prevPosts.map(existingPost =>
                    existingPost._id === post._id
                        ? post
                        : existingPost
                )
            );
        };


        const handlePostDeleted = ({ posts }) => {

            if (posts) {
                setPosts(posts);
            }
        };


        socket.on(
            'likeUpdated',
            handleLikeUpdated
        );

        socket.on(
            'commentUpdated',
            handleCommentUpdated
        );

        socket.on(
            'post-deleted',
            handlePostDeleted
        );


        return () => {

            socket.off(
                'likeUpdated',
                handleLikeUpdated
            );

            socket.off(
                'commentUpdated',
                handleCommentUpdated
            );

            socket.off(
                'post-deleted',
                handlePostDeleted
            );

        };

    }, [socket]);


    // =========================
    // LIKE
    // =========================
    const handleLike = (userId, postId) => {

        socket.emit(
            'postLiked',
            {
                userId,
                postId
            }
        );

    };


    // =========================
    // UNLIKE
    // =========================
    const handleUnLike = (userId, postId) => {

        socket.emit(
            'postUnLiked',
            {
                userId,
                postId
            }
        );

    };


    // =========================
    // FOLLOW
    // =========================
    const handleFollow = (userId) => {

        socket.emit(
            'followUser',
            {
                ownId: localStorage.getItem('userId'),
                followingUserId: userId
            }
        );

    };


    // =========================
    // FOLLOW STATE
    // =========================
    useEffect(() => {

        const handleUserFollowed = ({
            following
        }) => {

            localStorage.setItem(
                'following',
                following
            );

            // Force component to re-render
            setPosts(prevPosts => [...prevPosts]);

        };


        socket.on(
            'userFollowed',
            handleUserFollowed
        );


        return () => {

            socket.off(
                'userFollowed',
                handleUserFollowed
            );

        };

    }, [socket]);


    // =========================
    // COMMENT
    // =========================
    const handleComment = (
        postId,
        username
    ) => {

        if (!comment.trim()) {
            return;
        }

        socket.emit(
            'makeComment',
            {
                postId,
                username,
                comment: comment.trim()
            }
        );

        setComment('');

    };


    return (
        <div className='postsContainer'>

            {posts.map((post) => {

                const following =
                    localStorage.getItem('following') || '';

                const currentUserId =
                    localStorage.getItem('userId');


                return (

                    <div
                        className="Post"
                        key={post._id}
                    >

                        <div className="postTop">

                            <div className="postTopDetails">

                                <img
                                    src={post.userPic}
                                    alt=""
                                    className="userpic"
                                />

                                <h3
                                    className="usernameTop"
                                    onClick={() =>
                                        navigate(
                                            `/profile/${post.userId}`
                                        )
                                    }
                                >
                                    {post.userName}
                                </h3>

                            </div>


                            {!following.includes(post.userId) &&
                                currentUserId !== post.userId && (

                                    <IoIosPersonAdd
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        id='addFriendInPost'
                                        onClick={() =>
                                            handleFollow(
                                                post.userId
                                            )
                                        }
                                    />

                                )}

                        </div>


                        {post.fileType === 'photo' ? (

                            <img
                                src={post.file}
                                className='postimg'
                                alt=""
                            />

                        ) : (

                            <video
                                id="videoPlayer"
                                className='postimg'
                                controls
                                autoPlay
                                muted
                            >
                                <source
                                    src={post.file}
                                />
                            </video>

                        )}


                        <div className="postReact">

                            <div className="supliconcol">

                                {post.likes.includes(
                                    currentUserId
                                ) ? (

                                    <AiTwotoneHeart
                                        className='support reactbtn'
                                        onClick={() =>
                                            handleUnLike(
                                                currentUserId,
                                                post._id
                                            )
                                        }
                                    />

                                ) : (

                                    <AiOutlineHeart
                                        className='support reactbtn'
                                        onClick={() =>
                                            handleLike(
                                                currentUserId,
                                                post._id
                                            )
                                        }
                                    />

                                )}

                                <label
                                    className='supportCount'
                                >
                                    {post.likes.length}
                                </label>

                            </div>


                            <div className="placeiconcol">

                                <FaGlobeAmericas
                                    className='placeicon reactbtn'
                                />

                                <label className='place'>
                                    {post.location}
                                </label>

                            </div>

                        </div>


                        <div className="detail">

                            <div className='descdataWithBtn'>

                                <label
                                    className="desc labeldata"
                                    id='desc'
                                >

                                    <span
                                        style={{
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {post.userName}
                                    </span>

                                    &nbsp;

                                    {post.description}

                                </label>

                            </div>

                        </div>


                        <div className="commentsContainer">

                            <div className="makeComment">

                                <input
                                    type="text"
                                    placeholder='type something...'
                                    onChange={(e) =>
                                        setComment(
                                            e.target.value
                                        )
                                    }
                                    value={comment}
                                />


                                {comment.length === 0 ? (

                                    <button
                                        className='btn btn-primary'
                                        disabled
                                    >
                                        comment
                                    </button>

                                ) : (

                                    <button
                                        className='btn btn-primary'
                                        onClick={() =>
                                            handleComment(
                                                post._id,
                                                localStorage.getItem(
                                                    'username'
                                                )
                                            )
                                        }
                                    >
                                        comment
                                    </button>

                                )}

                            </div>


                            <div className="commentsBody">

                                <div className="comments">

                                    {post.comments.map(
                                        (comment, index) => (

                                            <p
                                                key={`${post._id}-${index}`}
                                            >
                                                <b>
                                                    {comment[0]}
                                                </b>{' '}
                                                {comment[1]}
                                            </p>

                                        )
                                    )}

                                </div>

                            </div>

                        </div>

                    </div>

                );

            })}

        </div>
    );
};

export default Post;
